export const refreshPage = () => {
  const refreshedUrl = new URL(window.location.href);
  refreshedUrl.searchParams.set("refresh", Date.now().toString());
  window.location.replace(refreshedUrl.toString());
};
